import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const RouteElement = document.querySelector("#root");
const Route = ReactDOM.createRoot(RouteElement);
Route.render(App);
